import { useState, useEffect } from 'react';
import {
    Header,
    Segment,
    Grid,
    Icon,
    Message,
    Step
} from 'semantic-ui-react';
import PartnerIDModal from '../../partner-id/PartnerIDModal';
import { DateTime } from 'luxon';

function Operation() {
    // const userData = JSON.parse(window.localStorage.getItem('user')) || {};
    // const partnerIDData = JSON.parse(window.localStorage.getItem('partnerID')) || {};
    const [userData, setUserData] = useState({});
    const [partnerIDData, setPartnerIDData] = useState({});

    useEffect(() => {
        try {
            const user = JSON.parse(localStorage.getItem('user')) || {};
            const partnerID = JSON.parse(localStorage.getItem('partnerID')) || {};
            setUserData(user);
            setPartnerIDData(partnerID);
        } catch {
            setUserData({});
            setPartnerIDData({});
        }
    }, []);


    const { approved } = userData;
    const {
        partnerIDStatus = null,
        approvedDate = null,
        courierService = null,
        trackingNumber = null,
        deliveryMethod = null,
        handoverDate = null
    } = partnerIDData;

    const getActiveStep = () => {
        if (!approved) return 0;
        if (approved && partnerIDStatus === null) return 1;
        if (partnerIDStatus === "Requested") return 2;
        if (partnerIDStatus === "Approved") return 3;
        if (partnerIDStatus === "Delivered") return 4;
        return -1;
    };

    const activeStep = getActiveStep();

    return (
        <Grid centered>
            <Grid.Column>
                {/* Step Progress Tracker */}
                <Step.Group ordered fluid>

                    <Step active={activeStep === 0} completed={activeStep > 0}>
                        <Step.Content>
                            <Step.Title>Account Approved</Step.Title>
                            <Step.Description>Your user account has been approved</Step.Description>
                        </Step.Content>
                    </Step>

                    <Step active={activeStep === 1} completed={activeStep > 1}>
                        <Step.Content>
                            <Step.Title>Request Partner ID</Step.Title>
                            <Step.Description>Submit your Partner ID request</Step.Description>
                        </Step.Content>
                    </Step>

                    <Step active={activeStep === 2} completed={activeStep > 2}>
                        <Step.Content>
                            <Step.Title>Request Submitted</Step.Title>
                            <Step.Description>Partner ID request is under review</Step.Description>
                        </Step.Content>
                    </Step>

                    <Step active={activeStep === 3} completed={activeStep > 3}>
                        <Step.Content>
                            <Step.Title>Partner ID Approved</Step.Title>
                            <Step.Description>Your Partner ID is being prepared</Step.Description>
                        </Step.Content>
                    </Step>

                    <Step active={activeStep === 4} completed={activeStep > 4}>
                        <Step.Content>
                            <Step.Title>Partner ID Delivered</Step.Title>
                            <Step.Description>Your Partner ID has been delivered</Step.Description>
                        </Step.Content>
                    </Step>

                </Step.Group>


                {/* Optional: Show Hold Warning if applicable */}
                {partnerIDStatus === "Hold" && (
                    <Message warning style={{ marginTop: '20px' }}>
                        <Message.Header>Your Partner ID request is currently on hold.</Message.Header>
                        <p>Please contact <strong>Hikvision Technical Support</strong> to clarify the reason and resolve the issue.</p>
                    </Message>
                )}

                {/* Main Display Segment */}
                <Segment placeholder>
                    {
                        !approved ? (
                            <Grid centered columns={3} padded>
                                <Message warning style={{ marginTop: '40px' }}>
                                    <Message.Header>Your account is not approved yet.</Message.Header>
                                    <p>Please wait for approval before requesting a Partner ID.</p>
                                </Message>
                            </Grid>
                        ) : approved && partnerIDStatus === null ? (
                            <Grid columns={4} stackable textAlign="center">
                                <Grid.Column>
                                    <Header icon>
                                        <Icon name="id card" />
                                        Request Partner ID
                                    </Header>
                                    <PartnerIDModal />
                                </Grid.Column>
                            </Grid>
                        ) : partnerIDStatus === "Requested" ? (
                            <Grid centered columns={3} padded>
                                <Message info style={{ marginTop: '40px' }}>
                                    <Message.Header>Your Partner ID request has been submitted.</Message.Header>
                                    <p>We are reviewing your request, and it will be processed within 7–10 business days. You will be notified once it is approved.</p>
                                </Message>
                            </Grid>
                        ) : partnerIDStatus === "Approved" ? (
                            <Grid centered columns={3} padded>
                                <Message info style={{ marginTop: '40px' }}>
                                    <Message.Header>
                                        Your Partner ID was approved on {DateTime.fromISO(approvedDate).toFormat('yyyy/M/d')}.
                                    </Message.Header>
                                    <p>We are currently preparing your ID. You will be notified once it is handed over.</p>
                                </Message>
                            </Grid>
                        ) : partnerIDStatus === "Delivered" ? (
                            <Grid centered columns={3} padded>
                                <Message info style={{ marginTop: '40px' }}>
                                    {deliveryMethod === 'courier' ? (
                                        <>
                                            <Message.Header>
                                                Your Partner ID was handed over to {courierService} on{" "}
                                                {DateTime.fromISO(handoverDate).toFormat('yyyy/M/d')}.
                                            </Message.Header>
                                            <p>Use tracking number <strong>{trackingNumber}</strong> to check the delivery status.</p>
                                        </>
                                    ) : deliveryMethod === 'pickup' ? (
                                        <>
                                            <Message.Header>Your Partner ID has been collected.</Message.Header>
                                            <p>You picked it up on <strong>{DateTime.fromISO(handoverDate).toFormat('yyyy/M/d')}</strong>.</p>
                                        </>
                                    ) : null}
                                </Message>
                            </Grid>
                        ) : null
                    }
                </Segment>
            </Grid.Column>
        </Grid>
    );
}

export default Operation;



